import queryString from 'query-string';
import { makeRequest, objectToFormData, SADUKA_TRANSPORT_PREFIX } from 'cityads-v3/utils/apiUtils';
import { unique } from 'cityads-v3/utils/arrayUtils';
import { USER_ROLE_CODE_MANAGER } from 'cityads-v3/reducers/auth'

export const GET_ACTION_TYPE_DIRECTIONS = "offers/GET_ACTION_TYPE_DIRECTIONS";
export const GET_ACTION_TYPE_DIRECTIONS_SUCCESS = "offers/GET_ACTION_TYPE_DIRECTIONS_SUCCESS";
export const GET_ACTION_TYPE_DIRECTIONS_FAIL = "offers/GET_ACTION_TYPE_DIRECTIONS_FAIL";

export const GET_CATEGORIES = "offers/GET_CATEGORIES";
export const GET_CATEGORIES_SUCCESS = "offers/GET_CATEGORIES_SUCCESS";
export const GET_CATEGORIES_FAIL = "offers/GET_CATEGORIES_FAIL";

export const GET_COUPON_CATEGORIES = "offers/GET_COUPON_CATEGORIES";
export const GET_COUPON_CATEGORIES_SUCCESS = "offers/GET_COUPON_CATEGORIES_SUCCESS";
export const GET_COUPON_CATEGORIES_FAIL = "offers/GET_COUPON_CATEGORIES_FAIL";

export const GET_OFFER_TAGS = "offers/GET_OFFER_TAGS";
export const GET_OFFER_TAGS_SUCCESS = "offers/GET_OFFER_TAGS_SUCCESS";
export const GET_OFFER_TAGS_FAIL = "offers/GET_OFFER_TAGS_FAIL";

export const GET_REGIONS = "offers/GET_REGIONS";
export const GET_REGIONS_SUCCESS = "offers/GET_REGIONS_SUCCESS";
export const GET_REGIONS_FAIL = "offers/GET_REGIONS_FAIL";

export const GET_TOOLS = "offers/GET_TOOLS";
export const GET_TOOLS_SUCCESS = "offers/GET_TOOLS_SUCCESS";
export const GET_TOOLS_FAIL = "offers/GET_TOOLS_FAIL";

export const GET_OFFERS = "offers/GET_OFFERS";
export const GET_OFFERS_SUCCESS = "offers/GET_OFFERS_SUCCESS";
export const GET_OFFERS_FAIL = "offers/GET_OFFERS_FAIL";

export const GET_COUPONS = "offers/GET_COUPONS";
export const GET_COUPONS_SUCCESS = "offers/GET_COUPONS_SUCCESS";
export const GET_COUPONS_FAIL = "offers/GET_COUPONS_FAIL";

export const GET_OFFER_BY_ID = "offers/GET_OFFER_BY_ID";
export const GET_OFFER_BY_ID_SUCCESS = "offers/GET_OFFER_BY_ID_SUCCESS";
export const GET_OFFER_BY_ID_FAIL = "offers/GET_OFFER_BY_ID_FAIL";

export const GET_OFFERS_BY_IDS = "offers/GET_OFFERS_BY_IDS";
export const GET_OFFERS_BY_IDS_SUCCESS = "offers/GET_OFFERS_BY_IDS_SUCCESS";
export const GET_OFFERS_BY_IDS_FAIL = "offers/GET_OFFERS_BY_IDS_FAIL";

export const GET_OFFER_LIST = "offers/GET_OFFER_LIST";
export const GET_OFFER_LIST_SUCCESS = "offers/GET_OFFER_LIST_SUCCESS";
export const GET_OFFER_LIST_FAIL = "offers/GET_OFFER_LIST_FAIL";

export const GET_COUPON_OFFERS = "offers/GET_COUPON_OFFERS";
export const GET_COUPON_OFFERS_SUCCESS = "offers/GET_COUPON_OFFERS_SUCCESS";
export const GET_COUPON_OFFERS_FAIL = "offers/GET_COUPON_OFFERS_FAIL";

export const GET_PROMO_ACTION_TYPES = "offers/GET_PROMO_ACTION_TYPES";
export const GET_PROMO_ACTION_TYPES_SUCCESS = "offers/GET_PROMO_ACTION_TYPES_SUCCESS";
export const GET_PROMO_ACTION_TYPES_FAIL = "offers/GET_PROMO_ACTION_TYPES_FAIL";

export const GET_PROMO_COUPON_STATUSES = "offers/GET_PROMO_COUPON_STATUSES";
export const GET_PROMO_COUPON_STATUSES_SUCCESS = "offers/GET_PROMO_COUPON_STATUSES_SUCCESS";
export const GET_PROMO_COUPON_STATUSES_FAIL = "offers/GET_PROMO_COUPON_STATUSES_FAIL";

export const GET_PROMO_COUPON_SCOPES = "offers/GET_PROMO_COUPON_SCOPES";
export const GET_PROMO_COUPON_SCOPES_SUCCESS = "offers/GET_PROMO_COUPON_SCOPES_SUCCESS";
export const GET_PROMO_COUPON_SCOPES_FAIL = "offers/GET_PROMO_COUPON_SCOPES_FAIL";

export const GET_TARGETS = "offers/GET_TARGETS";
export const GET_TARGETS_SUCCESS = "offers/GET_TARGETS_SUCCESS";
export const GET_TARGETS_FAIL = "offers/GET_TARGETS_FAIL";

export const GET_OFFER_STAT = "offers/GET_OFFER_STAT";
export const GET_OFFER_STAT_SUCCESS = "offers/GET_OFFER_STAT_SUCCESS";
export const GET_OFFER_STAT_FAIL = "offers/GET_OFFER_STAT_FAIL";

export const GET_USER_OFFER_HOLD = "offers/GET_USER_OFFER_HOLD";
export const GET_USER_OFFER_HOLD_SUCCESS = "offers/GET_USER_OFFER_HOLD_SUCCESS";
export const GET_USER_OFFER_HOLD_FAIL = "offers/GET_USER_OFFER_HOLD_FAIL";

export const GET_FILTER_COUNT = "offers/GET_FILTER_COUNT";
export const GET_FILTER_COUNT_SUCCESS = "offers/GET_FILTER_COUNT_SUCCESS";
export const GET_FILTER_COUNT_FAIL = "offers/GET_FILTER_COUNT_FAIL";

export const GET_COUPON_FEED_LINK = "offers/GET_COUPON_FEED_LINK";
export const GET_COUPON_FEED_LINK_SUCCESS = "offers/GET_COUPON_FEED_LINK_SUCCESS";
export const GET_COUPON_FEED_LINK_FAIL = "offers/GET_COUPON_FEED_LINK_FAIL";

export const GET_COUPON_LINK = "offers/GET_COUPON_LINK";
export const GET_COUPON_LINK_SUCCESS = "offers/GET_COUPON_LINK_SUCCESS";
export const GET_COUPON_LINK_FAIL = "offers/GET_COUPON_LINK_FAIL";

export const GET_COUPON_SECTORING = "offers/GET_COUPON_SECTORING";
export const GET_COUPON_SECTORING_SUCCESS = "offers/GET_COUPON_SECTORING_SUCCESS";
export const GET_COUPON_SECTORING_FAIL = "offers/GET_COUPON_SECTORING_FAIL";

export const SEND_REQUEST_FORM = "offers/SEND_REQUEST_FORM";
export const SEND_REQUEST_FORM_SUCCESS = "offers/SEND_REQUEST_FORM_SUCCESS";
export const SEND_REQUEST_FORM_FAIL = "offers/SEND_REQUEST_FORM_FAIL";

export const CONNECT_TO_OFFER = "offers/CONNECT_TO_OFFER";
export const CONNECT_TO_OFFER_SUCCESS = "offers/CONNECT_TO_OFFER_SUCCESS";
export const CONNECT_TO_OFFER_FAIL = "offers/CONNECT_TO_OFFER_FAIL";

export const GET_CONNECT_REQUESTS = "offers/GET_CONNECT_REQUESTS";
export const GET_CONNECT_REQUESTS_SUCCESS = "offers/GET_CONNECT_REQUESTS_SUCCESS";
export const GET_CONNECT_REQUESTS_FAIL = "offers/GET_CONNECT_REQUESTS_FAIL";

export const GET_FAVORITES = 'offers/GET_FAVORITES';
export const GET_FAVORITES_SUCCESS = 'offers/GET_FAVORITES_SUCCESS';
export const GET_FAVORITES_FAIL = 'offers/GET_FAVORITES_FAIL';

export const SET_FAVORITE = 'offers/SET_FAVORITE';
export const SET_FAVORITE_SUCCESS = 'offers/SET_FAVORITE_SUCCESS';
export const SET_FAVORITE_FAIL = 'offers/SET_FAVORITE_FAIL';

export const SEND_SUGGEST_FORM = "offers/SEND_SUGGEST_FORM"
export const SEND_SUGGEST_FORM_SUCCESS = "offers/SEND_SUGGEST_FORM_SUCCESS"
export const SEND_SUGGEST_FORM_FAIL = "offers/SEND_SUGGEST_FORM_FAIL";

export const SET_GET_LINK_FORM = 'offers/SET_GET_LINK_FORM'

export const CLEAR_OFFER_LIST = 'offers/CLEAR_OFFER_LIST';
export const CLEAR_COUPON_LIST = 'offers/CLEAR_COUPON_LIST';
export const CLEAR_SUGGEST_OFFER_FORM_STATE = 'offers/CLEAR_SUGGEST_OFFER_FORM_STATE';

export function getActionTypeDirections() {
  return makeRequest(`${SADUKA_TRANSPORT_PREFIX}/actionTypeDirections`, {
    types: [GET_ACTION_TYPE_DIRECTIONS, GET_ACTION_TYPE_DIRECTIONS_SUCCESS, GET_ACTION_TYPE_DIRECTIONS_FAIL],
    options: {
      credentials: 'include'
    },
  });
}

export function getCategories() {
  return makeRequest(`/saduka/category/tree`, {
    types: [GET_CATEGORIES, GET_CATEGORIES_SUCCESS, GET_CATEGORIES_FAIL],
    options: {
      credentials: 'include'
    },
  });
}


export function getCouponCategories() {
  return makeRequest(`/saduka/category/tree?for_coupons=1`, {
    types: [GET_COUPON_CATEGORIES, GET_COUPON_CATEGORIES_SUCCESS, GET_COUPON_CATEGORIES_FAIL],
    options: {
      credentials: 'include'
    },
  });
}

export function getOfferTags() {
  return function (dispatch, getState, extraArgument) {
    const isBlogger = getState().auth.user?.isBlogger;
    const isManager = getState().auth.user?.user_role_code === USER_ROLE_CODE_MANAGER;
    const language = getState().language.language;

    return makeRequest(`${SADUKA_TRANSPORT_PREFIX}/offerTags?${queryString.stringify({ perpage: 1000, is_for_blogger: isBlogger ? true : null })}&${isManager && 'mng'}`, {
      types: [GET_OFFER_TAGS, GET_OFFER_TAGS_SUCCESS, GET_OFFER_TAGS_FAIL],
      options: {
        credentials: 'include'
      },
      language,
    })(dispatch, getState, extraArgument);
  }
}

export function getRegions() {
  return makeRequest('/saduka/geo/tree?area_id=0', {
    types: [GET_REGIONS, GET_REGIONS_SUCCESS, GET_REGIONS_FAIL],
    options: {
      credentials: 'include'
    },
  });
}

export function getTools() {
  return makeRequest(`${SADUKA_TRANSPORT_PREFIX}/tools/countOffersBelongingToEntity?is_active=true`, {
    types: [GET_TOOLS, GET_TOOLS_SUCCESS, GET_TOOLS_FAIL],
    options: {
      credentials: 'include'
    },
  });
}

export function getTargets(url, id) {
  return makeRequest('/saduka/offerTargets?perpage=1000&has_commission=1&is_active_only=1&today_only=1&offer_id=' + id, {
    types: [GET_TARGETS, GET_TARGETS_SUCCESS, GET_TARGETS_FAIL],
    options: {
      credentials: 'include'
    },
    id
  });
}

export function getOfferStat(ids) {
  const filter = ids.map(item => 'offers_ids[]=' +  encodeURIComponent(item)).join('&');
  return makeRequest('/saduka/offers/stat?' + filter, {
    types: [GET_OFFER_STAT, GET_OFFER_STAT_SUCCESS, GET_OFFER_STAT_FAIL],
    options: {
      credentials: 'include'
    },
    ids
  });
}

export function getUserOfferHold(offerId) {
  return function (dispatch, getState, extraArgument) {
    const userId = getState().auth.user?.id;

    return makeRequest('/saduka/userToOfferHolds?user_id=' + encodeURIComponent(userId) + '&offer_id=' + encodeURIComponent(offerId), {
      types: [GET_USER_OFFER_HOLD, GET_USER_OFFER_HOLD_SUCCESS, GET_USER_OFFER_HOLD_FAIL],
      options: {
        credentials: 'include'
      },
      offerId,
      userId,
    })(dispatch, getState, extraArgument);
  }
}

/**
 * @todo можно переделать под
 * stringify({key: value})
 */
function paramsToQueryParams(params){
  const {filter, order, page, limit, additional = ''} = params;
  const queryParams = [];
  const isCount = (params.url && params.url.indexOf('/count') !== -1);
  const url = params.url || (params.isTypeCoupon ? '/saduka/promoCoupons' : '/saduka/offers') + (isCount ? '/count' : '') + '?';

  queryParams.push(queryString.stringify({
    ...filter,
    name: filter.name?.trim()
  }, { arrayFormat: 'bracket' }));

  if (order) {
    if (order[0] === '-') {
      queryParams.push('sort=' + order.substr(1) + '&sort_asc=false');
    } else {
      queryParams.push('sort=' + order + '&sort_asc=true');
    }
  }

  if (page) {
    queryParams.push('page=' + page);
  }

  if (limit) {
    queryParams.push('perpage=' + limit);
  }

  if (additional) {
    queryParams.push(additional);
  }

  return url + queryParams.join('&');
}

export function getOffers(params, signal) {
  const url = paramsToQueryParams({ ...params, isTypeCoupon: false });
  const { returnAction, page, limit } = params;
  const withFilters = params.filter && Object.keys(params.filter).some(key => {

    if (['is_favorite', 'type'].includes(key)) {
      return false;
    }

    if (Array.isArray(params.filter[key])) {
      return !!params.filter[key].length;
    }

    return !!params.filter[key];
  });

  if (returnAction) {
    return url;
  } else {
    return makeRequest(url, {
      types: [GET_OFFERS, GET_OFFERS_SUCCESS, GET_OFFERS_FAIL],
      options: {
        credentials: 'include',
        signal
      },
      page,
      limit,
      withFilters
    });
  }
}

export function getCoupons(params) {
  const url = paramsToQueryParams({ ...params, isTypeCoupon: true });
  const { returnAction, page, limit } = params;
  const withFilters = params.filter && Object.keys(params.filter).some(key => {

    if (['is_favorite', 'type'].includes(key)) {
      return false;
    }

    if (Array.isArray(params.filter[key])) {
      return !!params.filter[key].length;
    }

    return !!params.filter[key];
  });

  if (returnAction) {
    return url;
  } else {
    return makeRequest(url, {
      types: [GET_COUPONS, GET_COUPONS_SUCCESS, GET_COUPONS_FAIL],
      options: {
        credentials: 'include'
      },
      page,
      limit,
      withFilters
    });
  }

}

export function getCouponOffers() {
  return makeRequest('/saduka/offers?perpage=2000&has_coupon=true&sort=name&sort_asc=true', {
    types: [GET_COUPON_OFFERS, GET_COUPON_OFFERS_SUCCESS, GET_COUPON_OFFERS_FAIL],
    options: {
      credentials: 'include'
    }
  });
}

export function getPromoActionTypes() {
  return makeRequest(`${SADUKA_TRANSPORT_PREFIX}/promoActionTypes`, {
    types: [GET_PROMO_ACTION_TYPES, GET_PROMO_ACTION_TYPES_SUCCESS, GET_PROMO_ACTION_TYPES_FAIL],
    options: {
      credentials: 'include'
    }
  });
}

export function getPromoCouponStatuses() {
  return makeRequest(`${SADUKA_TRANSPORT_PREFIX}/promoCouponStatuses`, {
    types: [GET_PROMO_COUPON_STATUSES, GET_PROMO_COUPON_STATUSES_SUCCESS, GET_PROMO_COUPON_STATUSES_FAIL],
    options: {
      credentials: 'include'
    }
  });
}

export function getPromoCouponScopes() {
  return makeRequest('/saduka/promoCouponScopes', {
    types: [GET_PROMO_COUPON_SCOPES, GET_PROMO_COUPON_SCOPES_SUCCESS, GET_PROMO_COUPON_SCOPES_FAIL],
    options: {
      credentials: 'include'
    }
  });
}

export function getOfferById(id) {
  return makeRequest('/saduka/offers/' + id, {
    types: [GET_OFFER_BY_ID, GET_OFFER_BY_ID_SUCCESS, GET_OFFER_BY_ID_FAIL],
    options: {
      credentials: 'include'
    },
    id
  });
}

export function getOffersByIds({ids}) {
  const uniqueIds = unique(ids)
  const url = uniqueIds.map(id => `ids[]=${encodeURIComponent(id)}`).join('&');
  return makeRequest(`/saduka/offers?${url}`, {
    types: [GET_OFFERS_BY_IDS, GET_OFFERS_BY_IDS_SUCCESS, GET_OFFERS_BY_IDS_FAIL],
    options: {
      credentials: 'include'
    },
    ids: uniqueIds
  });
}

export function getOfferList(params) {
  return makeRequest(`/saduka/offers/list?${queryString.stringify(params, { arrayFormat: 'bracket' })}`, {
    types: [GET_OFFER_LIST, GET_OFFER_LIST_SUCCESS, GET_OFFER_LIST_FAIL],
    options: {
      credentials: 'include'
    },
    params,
  });
}

export function getFilterCount(params = {}, { total = false } = {}) {
  const url = paramsToQueryParams({
    ...params,
    url: '/saduka/' + ( params.isTypeCoupon ? 'promoCoupons' : 'offer') + '/count?'
  });

  return makeRequest(url, {
    types: [GET_FILTER_COUNT, GET_FILTER_COUNT_SUCCESS, GET_FILTER_COUNT_FAIL],
    options: {
      credentials: 'include'
    },
    params,
    total
  });
}

export function loadCouponFeedLink(params = {}, id = '') {
  const types = params.method === 'PATCH' ? ['none','none','none'] : [GET_COUPON_FEED_LINK, GET_COUPON_FEED_LINK_SUCCESS, GET_COUPON_FEED_LINK_FAIL];
  return makeRequest('/saduka/userFeeds' + (id ? '/' + id : ''), {
    types,
    options: {
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json'
      },
      method: params.method === 'PATCH' ? 'PATCH' : 'POST',
      body: JSON.stringify({
        userFeed: {
          ...params.filter,
          subaccount1: params.subaccount1 || '',
          subaccount2: params.subaccount2 || '',
          subaccount3: params.subaccount3 || '',
          subaccount4: params.subaccount4 || '',
          subaccount5: params.subaccount5 || '',
        }
      })
    }
  });
}

export function loadCouponLink(id) {
  return makeRequest('/saduka/promoCoupons/links/' + id, {
    types: [GET_COUPON_LINK, GET_COUPON_LINK_SUCCESS, GET_COUPON_LINK_FAIL],
    options: {
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json'
      }
    },
    id
  });
}

export function getCouponSectoring() {
  return makeRequest('/saduka/promoCoupons/availableSectoring', {
    types: [GET_COUPON_SECTORING, GET_COUPON_SECTORING_SUCCESS, GET_COUPON_SECTORING_FAIL],
    options: {
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json'
      }
    }
  });
}

export function getFavorites(offerIds) {
  const uniqueOfferIds = unique(offerIds);
  const offerIdsParam = uniqueOfferIds.join(',');

  return makeRequest(`/saduka/favoriteOffers?offer_ids=${encodeURIComponent(offerIdsParam)}`, {
    types: [GET_FAVORITES, GET_FAVORITES_SUCCESS, GET_FAVORITES_FAIL],
    options: {
      credentials: 'include',
    },
    offerIds: uniqueOfferIds,
  });
}

export function setFavorite(offerId, isFavorite = true) {
  return makeRequest('/saduka/favoriteOffers', {
    types: [SET_FAVORITE, SET_FAVORITE_SUCCESS, SET_FAVORITE_FAIL],
    options: {
      credentials: 'include',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        favoriteOffer: {
          offer_id: offerId,
          is_favorite: isFavorite
        },
      }),
    },
    offerId,
    isFavorite
  });
}

export function clearOfferList() {
  return {
    type: CLEAR_OFFER_LIST
  }
}

export function clearCouponList() {
  return {
    type: CLEAR_COUPON_LIST
  }
}

export function setGetLinkForm(form) {
  return {
    type: SET_GET_LINK_FORM,
    form
  }
}

export function getOffersExportEndpoint({ type = 'csv' } = {}) {
  return `/saduka/exportOffers?exportFormat=${type}&`;
}

export function getCouponsExportEndpoint({ type = 'xls' } = {}) {
  return `/saduka/promoCoupons/export/${type}?`;
}

export function connectToOffer(offerId) {
  return makeRequest(`/saduka/offer/connectRequest/${offerId}`, {
    types: [CONNECT_TO_OFFER, CONNECT_TO_OFFER_SUCCESS, CONNECT_TO_OFFER_FAIL],
    options: {
      credentials: 'include',
      method: 'POST',
    },
    offerId
  });
}

export function getConnectRequests(ids) {
  return makeRequest(`/saduka/offer/connectRequests?perpage=1000&offer_ids=${ids.join(',')}`, {
    types: [GET_CONNECT_REQUESTS, GET_CONNECT_REQUESTS_SUCCESS, GET_CONNECT_REQUESTS_FAIL],
    options: {
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json'
      }
    }
  });
}

export function sendRequestForm(offerId, form, files = []) {
  const formData = objectToFormData(form);
  files.forEach(file => {
    formData.append('attachment', file);
  })

  return makeRequest('/saduka/offer/accessRequest/' + offerId, {
    types: [SEND_REQUEST_FORM, SEND_REQUEST_FORM_SUCCESS, SEND_REQUEST_FORM_FAIL],
    options: {
      credentials: 'include',
      method: 'POST',
      body: formData
    },
    offerId
  });
}

export function sendSuggestOfferForm(url, message, file) {
  const form = new FormData()
  form.append('message', message)
  form.append('url', url)
  if (file) {
    form.append('file', file)
  }

  return makeRequest('/saduka/offerSuggestions', {
    types: [SEND_SUGGEST_FORM, SEND_SUGGEST_FORM_SUCCESS, SEND_SUGGEST_FORM_FAIL],
    options: {
      credentials: 'include',
      method: 'POST',
      body: form
    },
  })
}

export function clearSuggestOfferFormState() {
  return {
    type: CLEAR_SUGGEST_OFFER_FORM_STATE
  }
}
